// src/context/SidebarFrameContext.jsx
// ─────────────────────────────────────────────────────────────────────────────
// BoneFrame modülünün sidebar açık/kapalı durumunu yönetir.
// SidebarBeatContext ile aynı pattern — tamamen bağımsız.
// ─────────────────────────────────────────────────────────────────────────────
import React, { createContext, useContext, useState, useCallback } from "react";

const SidebarFrameContext = createContext(null);

export function SidebarFrameProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const openSidebar   = useCallback(() => setIsOpen(true),    []);
  const closeSidebar  = useCallback(() => setIsOpen(false),   []);
  const toggleSidebar = useCallback(() => setIsOpen(s => !s), []);

  return (
    <SidebarFrameContext.Provider value={{ isOpen, openSidebar, closeSidebar, toggleSidebar }}>
      {children}
    </SidebarFrameContext.Provider>
  );
}

export function useSidebarFrame() {
  const ctx = useContext(SidebarFrameContext);
  if (!ctx) throw new Error("useSidebarFrame must be used within SidebarFrameProvider");
  return ctx;
}
